'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$() {
  this.aRL = null;
  this.aS2 = null;
  this.aRO = null;
  this.aRP = false;
  this.aRU = null;
  this.aRV = false;
  this.aS0 = null;
  this.aS1 = false;
  this.aRM = null;
  this.aRN = false;
  this.aRY = null;
  this.aRZ = false;
  this.aRW = null;
  this.aRX = false;
  this.aRQ = null;
  this.aRR = false;
  this.aRS = null;
  this.aRT = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ = this;
  this.aRL = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$();
  this.aS2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aRL;
});
$p.eO = (function() {
  return this.aS2;
});
$p.bW = (function() {
  if ((!this.aRP)) {
    this.aRO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aRP = true;
  }
  return this.aRO;
});
$p.b9 = (function() {
  if ((!this.aRV)) {
    this.aRU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aRV = true;
  }
  return this.aRU;
});
$p.b3 = (function() {
  if ((!this.aS1)) {
    this.aS0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aS1 = true;
  }
  return this.aS0;
});
$p.aG = (function() {
  if ((!this.aRN)) {
    this.aRM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aRN = true;
  }
  return this.aRM;
});
$p.az = (function() {
  if ((!this.aRZ)) {
    this.aRY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aRZ = true;
  }
  return this.aRY;
});
$p.aY = (function() {
  if ((!this.aRX)) {
    this.aRW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aRX = true;
  }
  return this.aRW;
});
$p.Jk = (function() {
  if ((!this.aRR)) {
    this.aRQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Transport Document Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aRR = true;
  }
  return this.aRQ;
});
$p.bsn = (function() {
  if ((!this.aRT)) {
    this.aRS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aRT = true;
  }
  return this.aRS;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$, "app.data.data_point_types$package$TransportDocumentNumberForm$", ({
  Gy: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$() {
  this.aRJ = null;
  this.aRK = false;
  this.aRH = null;
  this.aRI = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aRK)) {
    this.aRJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aRK = true;
  }
  return this.aRJ;
});
$p.bs5 = (function() {
  if ((!this.aRI)) {
    this.aRH = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumberForm$().Jk();
    this.aRI = true;
  }
  return this.aRH;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$, "app.data.data_point_types$package$TransportDocumentNumber$", ({
  Gx: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$TransportDocumentNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Transport-Document-Number$.js.map
